import Datatable from "components/Common/dataTable";
import UserProfileHeader from "components/Common/ui/UserProfileHeader";
import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { Alert, Tag } from "antd";
import { formatToLocaleDate } from "utils/dateUtils";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import LeaveStatusBadge from "./LeaveStatusBadge";
import { showConfirmDialog } from "utils/confirmDialogUtils";

type Props = {
    dataSource: any[];
    loading?: boolean;
    onApprove?: (record: any) => void | undefined;
    onRejected?: (record: any) => void | undefined;
    dataPaginate: any;
    onChange: (pg: any) => void;
};
const LeaveTable: React.FC<Props> = ({ dataSource, loading, onApprove, onRejected, dataPaginate, onChange }) => {

    const { t } = useTranslation();
    // const defaultExpandedRowKeys = dataSource.filter((r: any) => r.status === "rejected")
    //     .map((r: any) => r.id);
    const columns = [
        {
            title: t("leave.form.user"),
            key: "user",
            render: (_: any, r: any) => (
                <UserProfileHeader
                    firstName={r.staff?.user?.firstName || ""}
                    lastName={r.staff?.user?.lastName || ""}
                    photo={r.staff?.user?.photo || ""}
                />
            ),
        },
        {
            title: t("leave.form.leaveType"),
            dataIndex: ["leaveType", "slug"],
            key: "leaveType",
            render: (_: any, r: any) => t("leave.types." + r.leaveType?.slug) || "—",
        },
        {
            title: t("leave.form.period"),
            dataIndex: "period",
            key: "period",
            render: (_: any, r: any) => t("leave.period." + r.period || "—"),
        },
        {
            title: t("leave.form.status"),
            dataIndex: "status",
            key: "status",
            align: "center" as const,
            render: (status: "pending" | "approved" | "rejected") => (
                <LeaveStatusBadge status={status} />
            ),
        },
        {
            title: t("leave.form.startDate"),
            dataIndex: "startDate",
            key: "startDate",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("leave.form.endDate"),
            dataIndex: "endDate",
            key: "endDate",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("leave.form.createdAt"),
            dataIndex: "createdAt",
            key: "createdAt",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("actions"),
            key: "actions",
            render: (_: string, record: any) => {
                const actions: Action[] = [
                    {
                        label: t("approved"),
                        icon: "ti ti-check",
                        actionType: "link",
                        hidden: record.status !== "pending" || !onApprove,
                        onClick: () => onApprove?.(record),
                    },
                    {
                        label: t("rejected"),
                        icon: "ti ti-x",
                        actionType: "link",
                        hidden: record.status !== "pending" || !onRejected,
                        onClick: () => onRejected?.(record),
                    }
                ];
                return record.status === "pending" ? <ActionsDropdown actions={actions} /> : <i className="ti ti-lock"></i>;
            },
        },
    ];


    return (
        <div className="table-responsive">
            <Datatable
                rowKey="id"
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={true}
                dataPaginate={dataPaginate}
                onChange={onChange}
                expandable={{
                    expandedRowRender: (record: any) =>
                        record.status === "rejected" ? (
                            <Alert
                                type="error"
                                showIcon
                                message={t("leave.form.reasonReject")}
                                description={
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            marginTop: 4,
                                        }}
                                    >
                                        {record.reasonReject}
                                    </div>
                                }
                            />
                        ) : null,
                    rowExpandable: (record: any) => record.status === "rejected",
                    expandedRowClassName: () => "bg-transparent",


                }}
            />
        </div>
    );
}
export default LeaveTable;

